export const GET_FEATURED_PENDING = 'getFeaturedPending';
export const GET_FEATURED_FULFILLED = 'getFeaturedFulfilled';
export const GET_FEATURED_REJECTED = 'getFeaturedRejected';

export const FEATURED_PAGINATION_PENDING = 'FeaturedPaginationPending';
export const FEATURED_PAGINATION_FULFILLED = 'FeaturedPaginationFulfilled';
export const FEATURED_PAGINATION_REJECTED = 'FeaturedPaginationRejected';

export const SET_URL_PARAMS_FEATURED = 'setUrlParamsFeatured';

